<template>
  <Modal v-model="visible" title="项目区域选择" width="90%" :mask-closable="false" @on-cancel="forceStop"
    @on-visible-change="handleVisibleChange" :footer-hide="true">
    <!-- 地图容器 + 工具栏（仿官网位置） -->

    <Modal title="示例展示说明" v-model="place_demo_show">
      <div>
        <div class="place_demo_hint">
          操作说明：在地图上划出项目厂区所处位置，用于员工签到定位等功能; 鼠标左键单击开始画线框选，鼠标右键单击撤销一步，鼠标左键双击自动闭合方块。如下图：
        </div>
        <div>
          <img src="@/assets/image/interview/project_place.png" alt="" style="width:450px;height:250px;">
        </div>
      </div>
    </Modal>
    <div class="caozuo_hint" v-if="visible">
      操作说明：在地图上划出项目厂区所处位置，用于员工签到定位等功能; 鼠标左键单击开始画线框选，鼠标右键单击撤销一步，鼠标左键双击自动闭合方块。<span clss="demo_span1"
        style="color: #0466dd;cursor: pointer;font-weight: 600;" @click="place_demo_show = true">查看示例图</span>
    </div>

    <div style="width: 100%; height: 75vh; position: relative">
      <div id="container" style="width: 100%; height: 100%;"></div>
      <div class="toolbar">
        <div class="tool-item" title="地点搜索" @click="search_location">
          <Icon type="ios-search" />地点搜索
        </div>
        <div class="tool-item" :class="{ active: isDrawMode }" @click.stop="onDraw" title="新增多边形">
          <Icon type="ios-add-circle-outline" />新增区域
        </div>
        <div class="tool-item" @click.stop="onDelete" title="删除选中图形">
          <Icon type="ios-trash-outline" />删除区域
        </div>
        <div class="tool-item" @click.stop="onClear" title="清除全部多边形">
          <Icon type="md-refresh" />清除全部区域
        </div>
      </div>
    </div>

    <!-- <div id="container" style="width: 100%; height: 90%; position: relative">
      <div class="toolbar">
        <div class="tool-item" :class="{ active: isDrawMode }" @click.stop="onDraw" title="新增多边形">
          <Icon type="ios-add-circle-outline" />新增区域
        </div>
        <div class="tool-item" @click.stop="onDelete" title="删除选中图形">
          <Icon type="ios-trash-outline" />删除区域
        </div>
        <div class="tool-item" @click.stop="onClear" title="清除全部多边形">
          <Icon type="md-refresh" />清除全部区域
        </div>
      </div>
    </div> -->

    <!-- <div slot="footer" class="modal_footer">
      <Button @click="cancel" style="margin-right:10px">取消</Button>
      <Button type="primary" @click="confirm">确定保存</Button>
    </div> -->
  </Modal>

  <Modal v-model="search_show" :mask-closable="true" :footer-hide="true" draggable title="地图中心点选择(可拖拽)" closable>
    <div>
      <div class="search_city_div">
        <div style="width:120px">
          <City v-model="search_city" show-suffix @on-change="city_change" />
        </div>

        <div style="width:100%;">
          <Input search enter-button :placeholder="'在 ' + search_city_name + ' 内搜索地点'" v-model="search_input"
            @on-search="search_location_request" @on-click="search_location_request" @on-enter="search_location_request"
            :disabled="search_loading" />
        </div>

      </div>
      <div class="search_list_div">
        <Spin fix v-if="search_loading"></Spin>
        <div v-for="(item, i) in search_list" :key="i"
          :class="search_id == item.id ? 'search_card_select' : 'search_card'" @click="click_place_card(item, i)">
          <div>
            <Icon type="md-pin" color="red" style="margin-right: 5px;" />
            {{ item.title }}
          </div>
          <div class="search_address">
            {{ item.address }}
          </div>
        </div>
        <div class="page_div">
          <Page :total="search_total_count" :page-size="search_limit" @on-change="page_change" />
        </div>
      </div>


    </div>



  </Modal>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

import {
  getMap,
  initPolygonEditor,
  deleteSelectedPolygon,
  getAllPolygonPaths,
  startDrawMode,
  startInteractMode,
  destroyEditor,
  clearAllPolygons

} from '@/utils/tmap'

export default {
  name: 'select_location',
  data() {
    return {
      visible: false,
      result: [],          // 所有多边形路径
      editor: null,
      existPaths: null,
      isDrawMode: false,    // 是否绘制模式（工具栏高亮）
      hasSelectedPolygon: false, // ✅ 是否选中多边形
      project_id: '',
      location_data: [],
      mapInstance: null,
      syncTimer: null,
      center_location: [],
      search_show: false,
      search_input: "",
      search_city: "430100",
      search_city_name: "长沙市",
      search_list: [],
      search_loading: false,
      search_id: '',
      search_total_count: 0,
      search_limit: 20,
      search_page: 1,

      place_demo_show: false
    }
  },

  beforeDestroy() {
    this.stop()
  },

  methods: {
    page_change(e) {
      console.log(e)
      this.search_page = e
      this.search_location_request()
    },

    click_place_card(item, i) {
      this.search_id = item.id
      this.center_location = [item.location.lat, item.location.lng]
      this.stop();
      this.init()
      let txt = '地图中心点已经切换，快去地图上划出厂区范围吧~~'
      this.$Message.info({
        content: txt,
        duration: 4
      });
    },

    city_change(e) {
      console.log(e)
      this.search_city_name = e.n
    },
    search_location_request() {
      this.search_loading = true

      var that = this
      var obj = {
        search_input: this.search_input,
        search_city_name: this.search_city_name,
        search_limit: this.search_limit,
        search_page: this.search_page
      }

      http("post", process.env.VUE_APP_HOST + "/common/search_place", obj, true).then(
        (res) => {
          if (res.code == 0) {
            that.search_list = res.data.search_data.data
            that.search_total_count = res.data.search_data.count
          } else {

          }
          that.search_loading = false
        }
      ).catch((res) => {
        console.log(res, '请求出错')
      })
    },
    search_location() {
      this.search_show = true
    },
    forceStop() {
      this.stop()
    },
    // 获取项目地点
    get_projet_location() {
      var that = this
      var obj = {
        project_id: this.project_id,

      }
      http("post", process.env.VUE_APP_HOST + "/my_project/project_detail/location/get_project_location", obj, true).then(
        (res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.existPaths = res.data.location_list
            that.center_location = res.data.center_location


            // this.existPaths = existPaths || null
            // this.existPaths = that.location_data
            this.result = that.existPaths ? [...that.existPaths] : []
            this.visible = true
            this.place_demo_show = true

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        }
      ).catch((res) => {
        console.log(res, '请求出错')
      })
    },

    //更新项目地点
    update_location() {
      var that = this
      var obj = {
        project_id: this.project_id,
        location_list: this.result

      }
      http("post", process.env.VUE_APP_HOST + "/my_project/project_detail/location/add_project_location", obj, true).then(
        (res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            let location_count = res.data.location_count
            this.$emit('change', location_count)
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        }
      ).catch((res) => {
        console.log(res, '请求出错')
      })
    },
    /**
     * 打开弹窗
     * @param {Array} existPaths - 回显数据，同 result 格式
     */
    open(project_id,) {

      this.project_id = project_id
      this.get_projet_location()
      console.log(project_id,)
    },

    handleVisibleChange(val) {
      console.log('页面关闭', val)
      if (val) {
        this.$nextTick(() => { this.init() })
      } else {

        this.stop()
      }
    },


    init() {
      const container = document.getElementById('container')
      if (!container) return

      // 销毁旧地图，避免多实例堆积
      if (this.mapInstance) {
        this.mapInstance.destroy()
        this.mapInstance = null
      }

      const map = getMap(container, this.center_location)
      this.mapInstance = map
      const { editor } = initPolygonEditor(map, this.existPaths)
      this.editor = editor
      this.isDrawMode = !this.existPaths || !this.existPaths.length

      this.editor.on('select', () => {
        this.hasSelectedPolygon = true
      })
      this.editor.on('unselect', () => {
        this.hasSelectedPolygon = false
      })
      this.editor.on('delete_complete', () => {
        this.hasSelectedPolygon = false
        this.syncResult()
      })

      const evtList = ['delete', 'adjust', 'split', 'union']
      evtList.forEach(name => {
        this.editor.on(name + '_complete', (evtResult) => {
          console.log(name + '_complete:', evtResult)
          this.syncResult()
        })
      })

      this.editor.on('draw_complete', () => {
        this.syncResult()
        this._needSwitchBack = false
        this.isDrawMode = false
        startInteractMode()
      })
    },

    stop() {
      clearTimeout(this.syncTimer)   // ✅ 防止销毁后还触发请求
      destroyEditor()
      this.editor = null
      if (this.mapInstance) {
        this.mapInstance.destroy()
        this.mapInstance = null
      }
    },

    // init() {
    //   const container = document.getElementById('container')
    //   if (!container) return



    //   const map = getMap(container)
    //   const { editor } = initPolygonEditor(map, this.existPaths)
    //   this.editor = editor
    //   this.isDrawMode = !this.existPaths || !this.existPaths.length


    //   // 选中
    //   this.editor.on('select', () => {
    //     this.hasSelectedPolygon = true
    //   })

    //   // 取消选中
    //   this.editor.on('unselect', () => {
    //     this.hasSelectedPolygon = false
    //   })
    //   // 删除后也可能没有选中
    //   this.editor.on('delete_complete', () => {
    //     this.hasSelectedPolygon = false
    //     this.syncResult()
    //   })
    //   // —— 与官网一致的事件监听 ——
    //   const evtList = ['delete', 'adjust', 'split', 'union']
    //   evtList.forEach(name => {
    //     this.editor.on(name + '_complete', (evtResult) => {
    //       console.log(name + '_complete:', evtResult)
    //       this.syncResult()
    //     })
    //   })

    //   this.editor.on('draw_complete', () => {
    //     this.syncResult()
    //     // 如果是工具栏切过来的绘制模式，画完自动切回交互模式
    //     this._needSwitchBack = false
    //     this.isDrawMode = false
    //     startInteractMode()

    //     // if (this._needSwitchBack) {
    //     //   this._needSwitchBack = false
    //     //   this.isDrawMode = false
    //     //   startInteractMode()

    //     // }
    //   })



    // },

    /** 从图层读取最新坐标 */
    syncResult() {

      clearTimeout(this.syncTimer)
      this.syncTimer = setTimeout(() => {
        this.result = getAllPolygonPaths()
        console.log(this.result)
        this.update_location()
      }, 500)   // 500ms 
    },

    // —— 工具栏按钮 ——
    onDraw() {
      startDrawMode()
      this.isDrawMode = true
      this._needSwitchBack = true   // 标记：画完自动切回交互模式

    },
    onClear() {

      clearAllPolygons()
      this.syncResult()
      this.isDrawMode = true
      this._needSwitchBack = true   // 标记：画完自动切回交互模式


    },

    onDelete() {
      if (!this.hasSelectedPolygon) {
        this.$Message.info('请先点击多边形区域进行选中，再进行删除')
        return;
      }
      console.log('点击删除')
      deleteSelectedPolygon()
      this.syncResult()
    },

    // stop() {
    //   destroyEditor()
    //   this.editor = null
    // },

    cancel() {
      this.visible = false
    },

    confirm() {
      this.$emit('on-confirm', this.result)
      this.visible = false
    }
  }
}
</script>

<style scoped>
.demo_span1 {}

.place_demo_hint {
  margin-bottom: 10px;
  color: #333;
}

.page_div {
  display: flex;
  justify-content: center;
  padding: 10px 0
}

.search_city_div {
  display: flex;
  align-items: center;
}

.search_card {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  margin: 10px 10px 0 10px;
  padding: 5px;
}

.search_card_select {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
  margin: 10px 10px 0 10px;
  padding: 5px;
  background-color: #f3f3f3;

}

.search_card:hover {
  background-color: #f3f3f3;
  cursor: pointer;
}

.search_address {
  font-size: 14px;
  color: #ccc;
}

.search_list_div {
  height: 400px;
  overflow: auto;
  margin-top: 10px;
  position: relative;
}

.caozuo_hint {
  font-size: 13px;
  margin-bottom: 5px;

}

.modal_footer {
  display: flex;
  justify-content: end;
}

.toolbar {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  margin: auto;
  width: 400px;
  z-index: 1001;
  display: flex;
  gap: 4px;
}

.tool-item {
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 #E4E7EF;
  background: #fff;
  border: 1px solid #fff;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.tool-item:hover {
  border-color: #1453ff;
}

.active {
  border-color: #1453ff;
  background-color: #1453ff;
  color: #fff;
}
</style>
